var map = {
	"./gameplay-chainspin-large.webp": [
		2906,
		2906
	],
	"./gameplay-chokwin-large.webp": [
		65985,
		65985
	],
	"./gameplay-coinebet-large.webp": [
		56300,
		56300
	],
	"./gameplay-flashsportscasino-large.webp": [
		72384,
		72384
	],
	"./gameplay-gannar-large.webp": [
		85916,
		85916
	],
	"./gameplay-luckykingbet-large.webp": [
		1320,
		1320
	],
	"./gameplay-mars-br-large.webp": [
		32402,
		32402
	],
	"./gameplay-mars-es-large.webp": [
		37781,
		37781
	],
	"./gameplay-mars-large.webp": [
		90860,
		90860
	],
	"./gameplay-mars-mx-large.webp": [
		39774,
		39774
	],
	"./gameplay-mars-pt-large.webp": [
		63533,
		63533
	],
	"./gameplay-mars-ru-large.webp": [
		36521,
		36521
	],
	"./gameplay-mars-th-large.webp": [
		50474,
		50474
	],
	"./gameplay-novero-large.webp": [
		40596,
		40596
	],
	"./gameplay-rollblock-large.webp": [
		31361,
		31361
	],
	"./gameplay-zenginsin-large.webp": [
		72651,
		72651
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47866;
module.exports = webpackAsyncContext;